import useTabState from '../hooks/useTabState';
import PageLayout from '../components/ui/PageLayout';
import TabBar from '../components/ui/TabBar';
import GLUpload from './GLUpload';
import DocumentUpload from './DocumentUpload';
import SFTPConfig from './SFTPConfig';
import FXRatesView from './FXRatesView';
import CoAMapping from './CoAMapping';

const TABS = ['GL Upload', 'Document Upload', 'SFTP', 'FX Rates', 'CoA Mapping'] as const;
type Tab = typeof TABS[number];

const TAB_KEYS: Record<string, Tab> = {
  gl_upload: 'GL Upload',
  document_upload: 'Document Upload',
  sftp: 'SFTP',
  fx_rates: 'FX Rates',
  coa_mapping: 'CoA Mapping',
};

export default function DataManagement() {
  const [activeTab, setActiveTab] = useTabState<Tab>('tab', TABS, 'GL Upload');
  const activeKey = activeTab.toLowerCase().replace(/\s+/g, '_');

  return (
    <PageLayout title="Data Management" subtitle="Data uploads, integrations, and mappings">
      <TabBar
        tabs={TABS as unknown as string[]}
        active={activeKey}
        onChange={k => { if (TAB_KEYS[k]) setActiveTab(TAB_KEYS[k]); }}
      />
      {activeTab === 'GL Upload' && <GLUpload />}
      {activeTab === 'Document Upload' && <DocumentUpload />}
      {activeTab === 'SFTP' && <SFTPConfig />}
      {activeTab === 'FX Rates' && <FXRatesView />}
      {activeTab === 'CoA Mapping' && <CoAMapping />}
    </PageLayout>
  );
}
